import { useState } from 'react'

const ProjectAdminModel = () => {
  const [ isLoading, setIsLoading ] = useState<Record<string, boolean>>({ search: false, accounts: false, projects: false  });
  const [ accountsLoaded, setAccountsLoaded ] = useState<boolean>(false)
  const [ accounts, setAccounts ] = useState<[]>([])
  const [ projects, setProjects ] = useState<[]>([])
  const [ projectsDialogOpened, setProjectsDialogOpened ] = useState<boolean>(false)

  return {
    accountsLoaded, setAccountsLoaded,
    accounts, setAccounts,
    isLoading, setIsLoading,
    projects, setProjects,
    projectsDialogOpened, setProjectsDialogOpened
  }
}

export default ProjectAdminModel